<div class="app-version">
    {{ getVersion() }}
</div>
